import React, { useEffect, useState } from "react"; 
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import {
  get_PujaFor_GetDropDownData_PujaFor,
  get_Puja_Data_Puja,
  get_Puja_GetSinglaData_Puja,
} from "../../../store/actions/CommanAction";
import user from "./../../../images/task/user.jpg";
import DatePicker from "react-datepicker";
import {
  editorConfig,
  getShowingDateText,
  getShowingMonthDateYear,
  ReactQuillFormats,
  ReactQuillModules,
} from "../Utility/Utility";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import { ClassicEditor } from "ckeditor5";
import ReactQuill from "react-quill-new";

const PoojaListAdd = ({ onClose, modalOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const PujaGetSinglaDataPuja = useSelector(
    (state) => state.feedBackReducer.PujaGetSinglaDataPuja
  );
  const PujaForGetDropDownDataPujaFor = useSelector(
    (state) => state.feedBackReducer.PujaForGetDropDownDataPujaFor
  );

  const PujaID = useSelector((state) => state.feedBackReducer.PujaID);

  const [EditValue, setEditValue] = useState();
  const [IsActive, setIsActive] = useState(true);
  const [statesChangeStatus, setStatesChangeStatus] = useState(false);
  const [file, setFile] = React.useState(null);
  const [imageFile, setImageFile] = useState(null);

  const [Value, SetValue] = useState({
    PujaName: "",
    PujaFor: "",
    PujaForID: "",
    GSTAmt: "",
    GSTInfo: "",
    TotalAmt: "",
    Amt: "",
    CurrentAmt: "",
    IsActive: "1",
    Discount: "",
    Durations: "",
    ShortDescription: "",
    Benefits: "",
    PujaDescription: "",
    Rating: "",

    DescriptionDoc: "",
    BenefitsDoc: "",

    IsSpecial: "",
    IsHomePage: false,
    CreatedByUser: "1",
  });
  const [pujaError, setPujaError] = useState("");
const [checkingPuja, setCheckingPuja] = useState(false);

  const fileHandler = (e) => {
    const file = e.target.files[0];
    const allowedExtensions =
      /(\.apng|\.png|\.jpg|\.jpeg|\.jfif|\.pjpeg|\.pjp)$/i;
    if (file) {
      if (allowedExtensions.exec(file.name)) {
        setFile(file);
      } else {
        swal("Please upload a valid image file");
      }
    }
  };
  useEffect(() => {
    Reset();
  }, []);

  useEffect(() => {
    if (modalOpen && PujaID == null) {
      SetValue({
        PujaName: "",
        PujaFor: "",
        PujaForID: "",
        GSTAmt: "",
        GSTInfo: "",
        TotalAmt: "",
        Amt: "",
        CurrentAmt: "",
        IsActive: "1",
        Discount: "",
        Durations: "",
        ShortDescription: "",
        Benefits: "",
        PujaDescription: "",
        Rating: "",
        DescriptionDoc: "",
        BenefitsDoc: "",
        IsSpecial: "",
        IsHomePage: false,
        CreatedByUser: "1",
      });
      setFile(null);
      setEditValue(null);
      setImageFile(null);
    }
  }, [modalOpen, PujaID]);

  const ChangeDropDown = (e, idField, nameField) => {
    const selectedOption = e;
    if (idField === "IsActive") {
      SetValue((prevValue) => ({
        ...prevValue,
        [idField]: selectedOption ? selectedOption.value : "",
      }));
    } else {
      SetValue((prevValue) => ({
        ...prevValue,
        [idField]: selectedOption ? selectedOption.value : "",
        [nameField]: selectedOption ? selectedOption.label : "",
      }));
    }
  };

  useEffect(() => {
    dispatch(get_PujaFor_GetDropDownData_PujaFor());
  }, []);

  useEffect(() => {
    if (PujaID) {
      dispatch(get_Puja_GetSinglaData_Puja(PujaID));
    }
  }, [PujaID]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    if (Value.CurrentAmt === "") {
      error = true;
      errorMsg = "Please fill original Price.";
    }
    if (Value.PujaName === "") {
      error = true;
      errorMsg = "Please fill PujaName.";
    }
    if (Value.PujaForID === "") {
      error = true;
      errorMsg = "Please select Category.";
    }
    if (Value.Rating === "") {
      error = true;
      errorMsg = "Please fill Rating.";
    }
    if (Value.Benefits === "") {
      error = true;
      errorMsg = "Please fill Benefits.";
    }
    if (Value.ShortDescription === "") {
      error = true;
      errorMsg = "Please fill Short Description.";
    }
     if (Value.PujaDescription === "") {
      error = true;
      errorMsg = "Please fill Puja Description.";
    }
    if (pujaError) {
  error = true;
  errorMsg = "Puja name already exists";
}
    if (!error) {
      try {
        const formData = new FormData();
        formData.append("image", file);

        formData.append("Data", JSON.stringify(Value));

        await AddUpdate("Puja/Insert_Puja", formData);
        dispatch(get_Puja_Data_Puja(IsActive));
       
        swal("Good job!", "Successfully Added", "success");
        Reset();
        onClose();
      } catch (error) {
        swal("Oops", error.message, "error");
      }
    } else {
      swal("Oops", errorMsg, "error");
    }
   
  };

  const handleAddFormUpdate = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    if (Value.CurrentAmt === "") {
      error = true;
      errorMsg = "Please fill original Price.";
    }
    if (Value.PujaName === "") {
      error = true;
      errorMsg = "Please fill PujaName.";
    }
    if (Value.PujaForID === "") {
      error = true;
      errorMsg = "Please select Category.";
    }
    if (Value.Rating === "") {
      error = true;
      errorMsg = "Please fill Rating.";
    }
    if (Value.Benefits === "") {
      error = true;
      errorMsg = "Please fill Benefits.";
    }
    if (Value.ShortDescription === "") {
      error = true;
      errorMsg = "Please fill Short Description.";
    }
     if (Value.PujaDescription === "") {
      error = true;
      errorMsg = "Please fill Puja Description.";
    }
if (pujaError) {
  error = true;
  errorMsg = "Puja name already exists";
}

    if (!error) {
      try {
       

        await AddUpdate("Puja/UpDate_Puja", Value);
        dispatch(get_Puja_Data_Puja(IsActive));
      
        swal("Good job!", "Successfully update", "success");
        //  Reset();
      } catch (error) {
        swal("Oops", error.message, "error");
      }
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  useEffect(() => {
    setEditValue(PujaGetSinglaDataPuja);
  }, [PujaGetSinglaDataPuja]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0 && PujaID != null) {
      SetValue({
        ...Value,
        PujaID: PujaID,
        PujaName: EditValue[0]?.PujaName,
        PujaFor: EditValue[0]?.PujaFor,
        PujaForID: EditValue[0]?.PujaForID,
        GSTAmt: EditValue[0]?.GSTAmt,
        GSTInfo: EditValue[0]?.GSTInfo,
        TotalAmt: EditValue[0]?.TotalAmt,
        Amt: EditValue[0]?.Amt,
        CurrentAmt: EditValue[0]?.CurrentAmt,
        IsActive: EditValue[0]?.IsActive,
        Discount: EditValue[0]?.Discount,
        Durations: EditValue[0]?.Durations,
        ShortDescription: EditValue[0]?.ShortDescription,
        Benefits: EditValue[0]?.Benefits,
        PujaDescription: EditValue[0]?.PujaDescription,
        Rating: EditValue[0]?.Rating,
        IsSpecial: EditValue[0]?.IsSpecial,
        DescriptionDoc: EditValue[0]?.DescriptionDoc,
        BenefitsDoc: EditValue[0]?.BenefitsDoc,
        IsHomePage: EditValue[0]?.IsHomePage,
        CreatedByUser: "1",
        PujaImage: EditValue[0]?.PujaImage,

        IsTrending: EditValue[0]?.IsTrending,
      });
    }
  }, [EditValue, PujaID]);

  const handleUpdatePhoto = async () => {
    if (!file) {
      swal("Error", "Please select a photo to upload", "error");
      return;
    }
    const formData = new FormData();
    const dataObject = {
      PujaID: PujaID,
      ModifiedByUser: "1",
    };
    formData.append("Data", JSON.stringify(dataObject));
    formData.append("File", file);
    try {
      await AddUpdate("Puja/UpdatePhoto_Puja", formData);
      swal("Good job!", "Successfully Added", "success");
    } catch (error) {
      swal("Error", "Failed to upload photo", "error");
    } finally {
      // setFile(null);
    }
  };

  const Reset = () => {
    SetValue({
      ...Value,
      Amt: "",
      ShortDescription: "",
      RegMobileNo: "",
      CurrentAmt: "",
      CreatedTime: "",
      PujaForID: "",
      PujaDescription: "",
      IsSpecial: "",
      GSTInfo: "",
      GSTAmt: "",
      TotalAmt: "",
      Rating: "",
      IsHomePage: false,
      PujaFor: "",
      PujaName: "",

      Benefits: "",
      Durations: "",
      Discount: "",
      DescriptionDoc: "",
      BenefitsDoc: "",
      // 'IsTrending': '',
    });
    setImageFile(null);
    setFile(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    

    const updatedValue = { ...Value, [name]: value };

    const originalPrice = parseFloat(updatedValue.CurrentAmt) || 0;
    const discount = parseFloat(updatedValue.Discount) || 0;

    const price = originalPrice - (originalPrice * discount) / 100;
    updatedValue.Amt = price.toFixed(2);

    const gstPercentage = parseFloat(updatedValue.GSTInfo) || 0;
    const gstAmt = (price * gstPercentage) / 100;
    updatedValue.GSTAmt = gstAmt.toFixed(2);

    // updatedValue.TotalAmt = Math.round(price + gstAmt);
    updatedValue.TotalAmt = price + gstAmt;

    SetValue(updatedValue);
  };

  

  const [imagePreview, setImagePreview] = useState(null);

  const handleImageChange = (event) => {
    setStatesChangeStatus(true);
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const OnChangeEditor = (value, name) => {
    SetValue((prevValue) => ({ ...prevValue, [name]: value }));
  };


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: '#fdba74',          
      boxShadow: 'none',               
      '&:hover': {
        borderColor: '#fdba74',         
      },
    }),
  };

const checkPujaExist = async (value) => {
  if (!value) {
    setPujaError("");
    return;
  }

  try {
    setCheckingPuja(true);

    const payload = {
      PujaID: Value.PujaID || 0,
      PujaName: value,
    };

    const res = await AddUpdate("Puja/PujaCheckNameExist", payload);

    
    const parsed = JSON.parse(res?.data?.data || "{}");
    const exist = parsed?.Table?.[0]?.PujaExist;

    if (exist == 1) {
      setPujaError("Puja name already exists");
    } else {
      setPujaError("");
    }

  } catch (err) {
    console.log("Puja check error", err);
  } finally {
    setCheckingPuja(false);
  }
};

useEffect(() => {
  const timer = setTimeout(() => {
    checkPujaExist(Value.PujaName);
  }, 500);

  return () => clearTimeout(timer);
}, [Value.PujaName]);

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card box_show">
            <div className="card-body">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item active">
                    <li className="breadcrumb-item active">
                      <Link to={`/PoojaList`}>PoojaList</Link>
                    </li>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Home
                  </li>
                </ol>
              </nav>
              <div className="">
                <div className="row">
                  <div className="col-10">
                    <div className="row">
                      <div className="form-group mb-3 col-6">
                        <label className="text-black font-w500">
                          Puja Name<span className="text-danger">*</span>
                        </label>
                        <div className="contact-name">
                          <input
                            autoComplete="off"
                            onChange={handleChange}
                            name="PujaName"
                            required="required"
                            value={Value.PujaName}
                            // className="form-control"
                            placeholder="PujaName"
                            maxLength={200}
                          />
{pujaError && (
  <small className="text-danger">{pujaError}</small>
)}

{checkingPuja && (
  <small>Checking...</small>
)}

                        </div>
                      </div>
                      <div className="form-group mb-3 col-6">
                        <label className="text-black font-w500">Category<span className="text-danger">*</span></label>
                        <div className="contact-name">
                          <Select
                            name="PujaForID"
                            value={PujaForGetDropDownDataPujaFor?.find(
                              (obj) => obj.value === Value?.PujaForID
                            )}
                            options={PujaForGetDropDownDataPujaFor}
                            onChange={(e) =>
                              ChangeDropDown(e, "PujaForID", "PujaFor")
                            }
                            placeholder="Select Highest BlogCategory"
                            isClearable
                            styles={customStyles}
                          />
                        </div>
                      </div>
                     

                      <div className="form-group mb-3 col-4">
                        <label className="text-black font-w500">
                          Original Price (₹)<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          // className="form-control"
                          name="CurrentAmt"
                          placeholder="Enter original price"
                          value={Value.CurrentAmt}
                          onChange={handleChange}
                          min={0}
                        />
                      </div>
                     
                      <div className="form-group mb-3 col-4">
                        <label className="text-black font-w500">
                          Discount (%)
                        </label>
                        <input
                          type="number"
                          // className="form-control"
                          name="Discount"
                          placeholder="Enter original price"
                          value={Value.Discount}
                          onChange={handleChange}
                          // min={0}
                        />
                      </div>
                      <div className="form-group mb-3 col-4">
                        <label className="text-black font-w500">
                          Price (₹)
                        </label>
                        <input
                          type="number"
                          // className="form-control"
                          name="Amt"
                          placeholder="Enter price"
                          value={Value.Amt}
                          onChange={handleChange}
                          min={0}
                        />
                      </div>

                     

                      <div className="form-group mb-3 col-4">
                        <label className="text-black font-w500">
                          GST Info(%)
                        </label>
                        <div className="contact-name">
                          <input
                            type="text"
                            autoComplete="off"
                            onChange={handleChange}
                            name="GSTInfo"
                            required="required"
                            value={Value.GSTInfo}
                            // className="form-control"
                            placeholder="ex. 18 %"
                            maxLength={200}
                          />
                        </div>
                      </div>

                      <div className="form-group mb-3 col-4">
                        <label className="text-black font-w500">GST Amt</label>
                        <div className="contact-name">
                          <input
                            type="text"
                            autoComplete="off"
                            onChange={handleChange}
                            name="GSTAmt"
                            required="required"
                            value={Value.GSTAmt}
                            // className="form-control"
                            placeholder="GSTAmt"
                            maxLength={8}
                          />
                        </div>
                      </div>

                      <div className="form-group mb-3 col-4">
                        <label className="text-black font-w500">
                          Total Amt
                        </label>
                        <div className="contact-name">
                          <input
                            autoComplete="off"
                            onChange={handleChange}
                            name="TotalAmt"
                            required="required"
                            value={Value.TotalAmt}
                            className=" readonly"
                            placeholder="TotalAmt"
                            maxLength={8}
                          />
                        </div>
                      </div>

                      <div className="form-group mb-3 col-6">
                        <label className="text-black font-w500">
                          Duration (in minutes)
                        </label>
                        <input
                          type="number"
                          // className="form-control"
                          name="Durations"
                          placeholder="Enter duration"
                          value={Value.Durations}
                          onChange={handleChange}
                          min={0}
                        />
                      </div>
                      <div className="form-group mb-3 col-6">
                        <label className="text-black font-w500">Status</label>
                        <Select
                          name="IsActive"
                          value={[
                            { value: true, label: "Active" },
                            { value: false, label: "Inactive" },
                          ].find((opt) => opt.value === Value.IsActive)}
                          options={[
                            { value: true, label: "Active" },
                            { value: false, label: "Inactive" },
                          ]}
                          onChange={(e) => ChangeDropDown(e, "IsActive")}
                          placeholder="Select Status"
                          styles={customStyles}
                          isClearable
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label className="text-black font-w500">
                          Short Description<span className="text-danger">*</span>
                        </label>
                        <div className="contact-name">
                          <textarea
                            rows={3}
                            cols={6}
                            autoComplete="off"
                            onChange={handleChange}
                            name="ShortDescription"
                            required="required"
                            value={Value.ShortDescription}
                            // className="form-control"
                            placeholder="Enter ShortDescription"
                            maxLength={200}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="profile">
                      <div className="profile-head">
                        <div className="profile-info">
                          <div className="image-placeholder">
                            <div className="avatar-edit">
                              <input
                                type="file"
                                onChange={fileHandler}
                                id="imageUpload"
                                onClick={(event) => setFile(event.target.value)}
                              />
                              <label
                                htmlFor="imageUpload"
                                style={{
                                  cursor: !PujaID ? "not-allowed" : "pointer",
                                  opacity: !PujaID ? 0.6 : 1,
                                }}
                              >
                                {" "}
                              </label>
                            </div>
                            <div className="avatar-preview">
                              <div id="imagePreview">
                                <img
                                  id="saveImageFile"
                                  src={
                                    file
                                      ? URL.createObjectURL(file)
                                      : Value.PujaImage
                                      ? `https://${Value.PujaImage.replace(
                                          /\\/g,
                                          "/"
                                        )}`
                                      : user
                                  }
                                  alt={file ? file.name : "User Avatar"}
                                  style={{
                                    cursor: !PujaID ? "not-allowed" : "pointer",
                                    opacity: !PujaID ? 0.6 : 1,
                                  }}
                                />
                              </div>
                            </div>
                            <button
                              onClick={handleUpdatePhoto}
                              disabled={!file || !PujaID}
                              className=" btn btn-primary text-white p-1 mx-3"
                            >
                              Upload Photo
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group mb-3 col-12">
                    <label className="text-black font-w500">Benefits<span className="text-danger">*</span></label>
                    <div class=" custom-ekeditor">
                      <ReactQuill
                        value={Value.Benefits}
                        // onChange={(value) => OnChangeEditor(value, 'Benefits')}

                        onChange={(value, delta, source, editor) => {
                          const text = editor?.getText();
                        
                          SetValue((prevValue) => ({
                            ...prevValue,
                            Benefits: value,
                            BenefitsDoc: text,
                          }));
                        }}
                        modules={ReactQuillModules}
                        formats={ReactQuillFormats}
                        theme="snow"
                        placeholder="Write something..."
                        // style={{ minHeight: '400px' }}
                      />
                    </div>
                  </div>
                  <div className="form-group mb-3 col-12">
                    <label className="text-black font-w500">Description<span className="text-danger">*</span></label>
                    <div class=" custom-ekeditor">
                      <ReactQuill
                        value={Value.PujaDescription}
                        // onChange={(value) =>
                        //   OnChangeEditor(value, "PujaDescription")
                        // }

                        onChange={(value, delta, source, editor) => {
                          const text = editor?.getText();
                         
                          SetValue((prevValue) => ({
                            ...prevValue,
                            PujaDescription: value,
                            DescriptionDoc: text,
                          }));
                        }}
                        modules={ReactQuillModules}
                        formats={ReactQuillFormats}
                        theme="snow"
                        placeholder="Write something..."
                      />
                    </div>
                  </div>
                  <div className="form-group mb-3 col-4">
                    <label className="text-black font-w500">Rating<span className="text-danger">*</span></label>
                    <div className="contact-name">
                      <input
                        type="number"
                        autoComplete="off"
                        name="Rating"
                        required="required"
                        value={Value?.Rating}
                        onChange={handleChange}
                        // className="form-control"
                        placeholder=""
                        min={0}
                        max={5}
                        onInput={(e) => {
                          if (e.target.value < 0) e.target.value = 0;
                          if (e.target.value > 5) e.target.value = 5;
                        }}
                        // onKeyDown={(e) => { e.preventDefault(); }}
                      />
                    </div>
                  </div>

                  <div className="form-group mb-3 col-4">
                    <label className="text-black font-w500">Is Home Page</label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        name="IsHomePage"
                        checked={Value?.IsHomePage || false}
                        onChange={(e) =>
                          SetValue((prev) => ({
                            ...prev,
                            IsHomePage: e.target.checked,
                          }))
                        }
                        className="form-check-input p-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                        id="isHomePageCheckbox"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {PujaID ? (
                  <button
                    className="btn btn-primary"
                    type="submit"
                    onClick={handleAddFormUpdate}
                  >
                    Update
                  </button>
                ) : (
                  <button
                    className="btn btn-primary"
                    type="submit"
                    onClick={handleAddFormSubmit}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PoojaListAdd;
